import { format } from 'date-fns';
import { fr, enUS } from 'date-fns/locale';
import i18n from 'i18next';

export const formatDate = (dateString) => {
    if (!dateString) {
        return '';
    }
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
        return '';
    }

    let formatPattern = "yyyy-MM-dd"; // Anglais (défaut)
    let locale = enUS;

    if (i18n.language.startsWith('fr')) { // Français
        formatPattern = "dd/MM/yyyy";
        locale = fr;
    }

    return format(date, formatPattern, { locale });
};

export const formatDateTime = (dateString) => {
    if (!dateString) {
        return '';
    }
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
        return '';
    }

    let formatPattern = "yyyy-MM-dd HH:mm"; // Anglais (défaut)
    let locale = enUS;

    if (i18n.language.startsWith('fr')) { // Français
        formatPattern = "dd/MM/yyyy HH:mm";
        locale = fr;
    }

    return format(date, formatPattern, { locale });
};

export const ROLE_SUPERADMIN = 1;
export const ROLE_ADMIN = 2;
export const ROLE_USER = 3;
export const ROLE_INTERNAL_API = 4;

export const getRoleName = (t, roleId) => {
    if (!roleId) return t('Not connected');
    const roles = getRoles(t, ROLE_SUPERADMIN);
    const role = roles.find((role) => role.value === roleId);
    return role ? role.label : t('Unknown role');
};

/**
 * Renvoie la liste des roles existants
 * @param {*} t
 * @param {int} currentRole Role de l'utilisateur actuel (car seul le superadmin a accès aux autres superadmins)
 * @returns 
 */
export const getRoles = (t, currentRole) => {
    if (currentRole === ROLE_SUPERADMIN) {
        return [
            { value: ROLE_SUPERADMIN, label: t('Super Admin') },
            { value: ROLE_ADMIN, label: t('Administrator') },
            { value: ROLE_USER, label: t('User') },
            { value: ROLE_INTERNAL_API, label: t('Internal API') },
        ];
    } else {
        return [
            { value: ROLE_ADMIN, label: t('Administrator') },
            { value: ROLE_USER, label: t('User') },
        ];
    }
}

export const isRoleAssociatedToCustomer = (role) => {
    role = parseInt(role);
    return role === ROLE_USER || role === ROLE_ADMIN;
}

export const getGenderName = (t, gender) => {
    if (gender === 'm') {
        return t('Mr');
    } else if (gender === 'f') {
        return t('Mrs');
    } else if (gender === 'o') {
        return t('Other');
    }
    return '';
};

export const formError = (error, t, setError, showMessage, errorIntro='Form validation error: {{msg}}') => {
    if (error.response && error.response.status === 422) {
        const serverErrors = error.response.data.errors;
        Object.keys(serverErrors).forEach((field) => {
            setError(field, {
                type: 'server',
                message: t(serverErrors[field][0]),
            });
        });
        showMessage(t(errorIntro, { msg: t(error.response.data.message) }), 'error');
    } else {
        showMessage(t(error.message), 'error');
    }
};

export const showDeleteResults = (results, showMessage, t, messageOne, messageMany) => {
    let nbSuccess = 0;
    let messagesError = [];
    Object.values(results.data).forEach(result => {
        if (result.success) {
            nbSuccess++;
        } else {
            const name = typeof result.name === 'object' ? extractBestTranslation(result.name, i18n.language) : result.name;
            messagesError.push(name + ' : ' + t(result.message));
        }
    });
    if (nbSuccess > 1) {
        showMessage(t(messageMany, { nb: nbSuccess }), 'success');
    } else if (nbSuccess === 1) {
        showMessage(t(messageOne, { nb: nbSuccess }), 'success');
    }
    if (messagesError.length > 0) {
        showMessage(messagesError.join(' ; '), 'error');
    }
}

export const extractBestTranslation = (translations, lang) => {
    if (!translations) {
        return '';
    }
    if (translations[lang]) {
        return translations[lang];
    }
    if (translations.en) {
        return translations.en;
    }
    return Object.values(translations)[0];
}

export const langs = {fr: 'French', en: 'English'};


export const createLanguageObject = (defaultValue = '', valueFn = () => defaultValue) => {
    // Crée un objet avec une valeur pour chaque langue
    return Object.keys(langs).reduce((accumulator, language) => {
        return {
            ...accumulator,
            [language]: valueFn(language)
        };
    }, {});
};

export const nl2br = (str) => {
    if (typeof str !== 'string') {
        return str;
    }
    return str.split(/\r\n|\r|\n/).map((line, i, arr) => (
        i === arr.length - 1 ? line : [line, <br key={i} />]
    ));
};
